import log from 'salvo-lite/log'
import AjaxCart from '../helpers/AjaxCart'
import scrollToElement from 'scroll-to-element'

class Product {
    constructor (theme) {
        this._theme = theme
        this._quantity = document.querySelector('[data-quantity]')
        this._quantityDecrease = this._quantity.querySelector('[data-decrease]')
        this._quantityIncrease = this._quantity.querySelector('[data-increase]')
        this._quanityInput = this._quantity.querySelector('input')
        this._add = document.querySelector('[data-product-add-to-cart]')
        this._id = document.querySelector('[name="id"]')
        this._videoTrigger = document.querySelectorAll('[data-video-trigger]')
        this._video = document.querySelector('[data-video]')
        this._form = document.querySelector('form.product__form')
        this._images = document.querySelectorAll('[data-image]')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._quantityDecrease.addEventListener('click', e => {
            if (this._quanityInput.value > 1) {
                this._quanityInput.value = parseInt(this._quanityInput.value) - 1
            }
        })
        this._quantityIncrease.addEventListener('click', e => {
            if (parseInt(this._quanityInput.value) < parseInt(this._quanityInput.max)) {
                this._quanityInput.value = parseInt(this._quanityInput.value) + 1
            }
        })
        this._form.addEventListener('submit', e => {
            e.preventDefault()
            this._addProduct()
        })
        if (this._videoTrigger) {
            this._videoTrigger.forEach(trigger => {
                trigger.addEventListener('click', e => {
                    this._videoEvents(trigger)
                })
            })
        }

        this._images.forEach(image => {
            image.addEventListener('click', e => {
                this._imageEvents(e.target)
            })
        })
    }
    async _addProduct () {
        const id = document.querySelector('[name="id"]').value // get ID inside method to prevent cache
        const quantity = this._quanityInput.value
        const payload = {quantity, id: id}
        await AjaxCart.addItem(payload)
    }
    _videoEvents (trigger) {
        const videoIcon = this._video.querySelector('.product__video-icon')
        if (trigger.dataset.videoTrigger === 'thumbnail') {
            this._images.forEach(image => {
                image.parentElement.classList.remove('large')
            })
            this._video.classList.add('active')
            scrollToElement(this._video, {
                offset: -80,
                duration: 750
            })
        }

        videoIcon.classList.add('visually-hidden')
        this._video.querySelector('video').play()

        this._video.querySelector('video').addEventListener('ended', e => {
            videoIcon.classList.remove('visually-hidden')
        })
    }

    // change featured image
    _imageEvents (item) {
        if (this._video) {
            this._video.classList.remove('active')
        }
        this._images.forEach(image => {
            image.parentElement.classList.remove('large')
        })
        item.parentElement.classList.add('large')
        scrollToElement(item, {
            offset: -50,
            duration: 750
        })
    }
}

export default Product



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Product.js